import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiModelFamiliesFetchFailedAction = {
	type: 'AI_MODEL_FAMILIES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiModelFamiliesFetchFailedAction => ({
	type: 'AI_MODEL_FAMILIES_FETCH_FAILED',
	payload,
});
